import { Chart as ChartJS } from "chart.js";
import DoughnutChart from "./Doughnut";
import LineChart from "./LineChart";
import StackedBarChart from "./StackedBarChart";

export { DoughnutChart, LineChart, StackedBarChart };
